import React from "react";

import { FilterOptions as FilterOptionsContainer } from "../../../shared/GridComponents";
import SessionTagPicker from "../../../shared/Forms/SessionTagPicker";
import TimezonePicker from "../../../shared/Forms/TimezonePicker";
import DatePicker from "../../../shared/Forms/DateTimePicker";

const FilterOptions = () => {
	return (
		<FilterOptionsContainer>
			<div className="row">
				<div className="sessions col-md-8">
					<SessionTagPicker field="sessionsFilter" placeholder="Filter By Tag" />
				</div>
				<div className="time-zone col-md-4">
					<TimezonePicker field="timeZone" placeholder="Schedule Timezone" />
				</div>
			</div>
			<div className="row">
				<div className="start-time col-md-6">
					<DatePicker field="startDate" placeholder="Items From" />
				</div>
				<div className="end-time col-md-6">
					<DatePicker field="endDate" placeholder="Items To" />
				</div>
			</div>
		</FilterOptionsContainer>
	);
};

export default FilterOptions;
